module.exports = __webpack_public_path__ + "img/booking-mobile.c672dc50.webp";